import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { PROPERTY_TYPES } from '../../constants';
import PropertyDetail from './PropertyDetail';
import {
  clearActiveBuilding,
  clearActiveSite,
  activateModal,
  setActiveTab,
  fetchBuilding,
  fetchSite,
} from '../../store/actions';
import {
  fetchBuildingOrSiteAreas,
  fetchAreaPolygon,
  fetchAreaData,
  fetchAreaDetails,
  loadingAreas,
} from '../../store/actions/areas';

const propertyAreas = {
  States: 'state',
  Regions: 'region',
  Counties: 'county',
  Communities: 'community',
};

export const mapStateToProps = (state, { type, match: { url } }) => {
  const activeArea = url.match(/state|region|county|community/g);
  let layer = '';
  if (activeArea && activeArea.length) {
    if (activeArea[0] === 'state') layer = 'states';
    if (activeArea[0] === 'region') layer = 'regions';
    if (activeArea[0] === 'county') layer = 'counties';
    if (activeArea[0] === 'community') layer = 'communities';
  }
  let detailInfoToShow = null;
  switch (layer) {
    case 'states':
      detailInfoToShow = state.viewer.areaSettings.stateInfoToShow;
      break;
    case 'counties':
      detailInfoToShow = state.viewer.areaSettings.countyInfoToShow;
      break;
    case 'communities':
      detailInfoToShow = state.viewer.areaSettings.communityInfoToShow;
      break;
    case 'regions':
      detailInfoToShow = state.viewer.areaSettings.regionInfoToShow;
      break;
    default:
      break;
  }

  // set tabs to display
  const tabs = ['overview', 'details'];
  const { viewer: { areaSettings: { areasPropertyDetail } } } = state;
  if (areasPropertyDetail === null || areasPropertyDetail === undefined) {
    tabs.push('state', 'region', 'county', 'community');
  } else {
    areasPropertyDetail.forEach(area => tabs.push(propertyAreas[area]));
  }

  const { basicInfo: { location: { county: countyId } = {} } = {} } = state[type].active || {};
  const defaultOrgContact = (state.viewer.contact || []).reduce((primary, contact) => {
    return (contact.isPrimary || contact.isprimary) ? contact : primary;
  }, undefined);
  const selectedOrgContact = (state.viewer.contact || []).reduce((selected, contact) => {
    if (contact.primaryFor && contact.primaryFor.includes(countyId)) {
      return contact;
    }
    return selected;
  }, undefined);

  return {
    // area: state[type].areaActive[layer],
    property: state[type].active,
    organizationId: state.organizationId,
    organizationContact: selectedOrgContact || defaultOrgContact,
    viewer: state.viewer,
    // overview: state[type].areasOverview,
    detailInfoToShow,
    areasLoading: state.areas.areasLoading,
    activePropertyTabs: tabs,
  };
};

export const mapDispatchToProps = (dispatch, { type }) => {
  const clearer = type === PROPERTY_TYPES.BUILDINGS ? clearActiveBuilding : clearActiveSite;
  const fetcher = type === PROPERTY_TYPES.BUILDINGS ? fetchBuilding : fetchSite;

  return {
    fetchProperty: async (id, orgId) => {
      return await dispatch(fetcher(id, false, orgId));
    },
    onCloseClick: () => dispatch(clearer()),
    goToList: () => dispatch(setActiveTab(type, 'tab-list')),
    routeToSubTab: (id, subTab, propertyName) => dispatch(push(`/${type}/${id}${subTab}/${propertyName}${window.location.search}`)),
    showSlideshow: id => { dispatch(activateModal(`slideshow-${id}`)); },
    showShareModal: () => { dispatch(activateModal('share-map')); },
    onDemographicsClick: () => { dispatch(activateModal('report')); },
    // copied from AreasWrapper for functions to handle header actions
    showDownloadModal: () => { dispatch(activateModal('download-property-area-files')); },
    showSpecialDownloadModal: () => { dispatch(activateModal('specialDownloadPropertyAreas')); },
    showModal: modal => { dispatch(activateModal(modal)); },
    showESRIModal: () => dispatch(activateModal('report')),
    // end
    getAreas: async (layer, org, location) => {
      dispatch(loadingAreas(layer, true));
      const area = await dispatch(fetchBuildingOrSiteAreas(layer, org, type, location));

      if (area) {
        await dispatch(fetchAreaPolygon(layer, area, type));

      // fetches info for the details tab for the area (ie. state|county|region|community)
      // type is building or site
      // area is the object fetched above that contains the areas ids needed to fetch
        await dispatch(fetchAreaDetails(layer, area, type));

      // fetches info for the overview tab for the area type (ie. state|county|region|community)
        await Promise.all([
          'race',
          'population',
          'labor',
          'populationByAge',
          'futurePopulationByAge',
          'malePopulationByAge',
          'femalePopulationByAge',
          'education',
          'housing',
          'industry',
          'income',
        ].map(async report => {
          const id = (layer === 'regions')
            ? area.counties.map(county => county.id).join()
            : area.id;
          await dispatch(fetchAreaData(layer, id, report, type, layer));
        }));
        await dispatch(fetchAreaData('national', '01', 'nationalIncome', type, layer));
      }

      await dispatch(loadingAreas(layer, false));
    },
  };
};

const PropertyDetailWrapper = connect(mapStateToProps,
  mapDispatchToProps)(PropertyDetail);

export default PropertyDetailWrapper;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailWrapper.js